var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFEDC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H16V29H19V22Z",
    fill: "#5E3911"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 22H22.5V29H25.5V22Z",
    fill: "#5E3911"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31H14V34H34V31Z",
    fill: "#5E3911"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22H29V29H32V22Z",
    fill: "#5E3911"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13L14 18V20H34V18L24 13Z",
    fill: "#5E3911"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBank);
export default __webpack_public_path__ + "static/media/button-bank.069c5a229d1b8a380ca034c2f236c0db.svg";
export { ForwardRef as ReactComponent };